import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';

import {initNavbarState} from 'actions/navbar.js';

import {colors, fontSizes, fonts} from 'style';
import ActivitiesContainer from './ActivitiesContainer.js';
import AnnouncementsContainer from './AnnouncementsContainer.js';

const ActivitiesTab = '/newsfeed';
const AnnouncementsTab = '/announcements';

var style={
    content: {
        position:'relative',
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeDarkerGrey,
    },
    title : {
        textAlign : 'center',
        marginRight : 'auto',
        marginLeft : 'auto',
        fontSize :  '42px',
        color : '#007FB9',
        marginTop : "24px"
    },
    tabBar: {
        position:'absolute', 
        top:'0px', 
        height:'40px', 
        width:'100%', 
        backgroundColor:'rgb(249, 249, 249)'
    },
    tabBarContent: {
        listStyle:'none',
        padding:'6px 0px 0px 0px',
        margin:'0 0 0 0',
        height:'100%',
        boxSizing:'border-box',
        textAlign:'center',
        color: '#fff',
        backgroundColor: colors.themeBlue,
    }, 
    tabContent: {
        boxSizing:'border-box', 
        paddingTop:'40px'
    },
    link: {
        float:'left', 
        width:'50%', 
        height:'100%',
        borderBottom : '0'
    },
    link_selected: {
        cursor: 'default',
        borderBottom : '0.4em solid #fff'
    }
};

class NewsFeed extends Component {
    constructor(props) {
        super(props);
        var selectedTab = (this.props.location.pathname==AnnouncementsTab) ? AnnouncementsTab : ActivitiesTab;
        this.state = {selectedTab: selectedTab};
        this.onClickTabSelect = this.onClickTabSelect.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', title:this.props.t('News Feed'), menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
    }

    componentWillReceiveProps(newProps) {
        var selectedTab = (newProps.location.pathname==AnnouncementsTab) ? AnnouncementsTab : ActivitiesTab;
        this.setState ({selectedTab: selectedTab});
    }

    onClickTabSelect(e) {
        this.selectTab(e.currentTarget.getAttribute('data-tab'));
    }

    selectTab(tab) {
        this.setState({selectedTab: tab});
        this.props.history.replace(tab);
    }

    selected(tab) {
        return (tab==this.state.selectedTab); 
    }

    render() {
        var t = this.props.t;
        return (
            <ActivitiesContainer pageTitle={this.props.t('community')} />
        );
    }

}


export default withRouter(connect()(translate('newsfeed')(NewsFeed)));



// WEBPACK FOOTER //
// ./src/modules/newsfeed/NewsFeed.js